import { render, staticRenderFns } from "./AddCommentDialog.vue?vue&type=template&id=d240f6f8"
import script from "./AddCommentDialog.vue?vue&type=script&lang=js"
export * from "./AddCommentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports